import { KYMW1311Model } from '../kymw1311.model';
import { KYMW1311CatalogDataCsvModel } from '../vo/kymw1311-catalog-data-csv.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 業態別企画書データ出力画面　業態別企画書データを出力するサービス
 *
 * @export OutputPlanDutiesFormCSVService
 * @class OutputPlanDutiesFormCSVService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPlanDutiesFormCSVService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1311Model}
   * @memberof OutputPlanDutiesFormCSVService
   */
  private model: KYMW1311Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1311CatalogDataCsvModel}
   * @memberof OutputPlanDutiesFormCSVService
   */
  private vo: KYMW1311CatalogDataCsvModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof OutputPlanDutiesFormCSVService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPlanDutiesFormCSVService
   */
  private getBody(): PlessRequest {
    let list =
      this.vo.dutiesFormDailyDivList.map(dailyDiv => {
        return {
          parameter: {
            DutiesFormDailyDiv: dailyDiv
          }
        }
      });
    let dailyDivList = !PlessViewUtilsSub.isEmptyArray(list) ? { combination: list } : {};

    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            OrderCodeFrom: this.vo.orderCodeFrom,
            OrderCodeTo: this.vo.orderCodeTo,
            PCode: this.vo.pCode,
            MediumType: this.vo.mediumType,
            DutiesFormWeeklyDiv: this.vo.dutiesWeeklyFlag,
            DutiesFormSpotDiv: this.vo.dutiesSpotFlag
          },
          combination: this.vo.classificationsList.map(classCode => {
            return {
              parameter: {
                ClassCode: classCode
              }
            }
          })
        },
        DutiesFormDailyDivList: dailyDivList
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof OutputPlanDutiesFormCSVService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1311Model>model;
    this.vo = <KYMW1311CatalogDataCsvModel>vo;
    this.successFunc = successFunc;
    this.send('outPutPlanDutiesFormCSV', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPlanDutiesFormCSVService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
